export default __webpack_public_path__ + "static/blog2-16cb885f959dd3aa10f5014b6f47686c.png";